<tc-company-logo [company]="company" class="picture"></tc-company-logo>
<div class="text">
  <div>
    <tc-company-name [company]="company"></tc-company-name>
  </div>
  <small *ngIf="accountCode">
    {{ accountCode }}
  </small>
</div>
